import { debounce } from "lodash";
import {
  ActivityIndicator,
  Image,
  Modal,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import React, { useEffect, useState, useCallback } from "react";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { FlatList } from "react-native-gesture-handler";
import Ionicons from "@expo/vector-icons/Ionicons";
import { toast } from "react-toastify";
import {
  searchUsers,
  sendChallenge,
  getUsersSuggestion,
  ChallengeUserNotificationHandler,
} from "../../../services/eventsAPI";
import { handleApiError } from "../../../services/errorHandler";
import { useNotifications } from "../../../context/NotificationContext";
import { ShowLoader } from "../../../common/ShowLoader";
import { NotificationType } from "../../../Api/configs";
import { getLoginData } from "../../../utility/AppStoreData";
import { NotificationUrl, chatUrl } from "../../../utility/Index";
import { Base64 } from "js-base64";
import { AppScreens } from "../../Utility/AppScreens";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import Avatar from "../../../Components/choose-avatar-components/Avatar";
import { storeUserActivity, ACTIVITY_TYPES } from "../../../services/activityService";

export default function SearchFromFriendsModal(props) {
  const {
    showModal = false,
    setShowModal,
    challengeDetails: challengeDetail,
    accessToken,
    successCallback,
    backTapped,
    onClose,
  } = props;

  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [showLoader, setShowLoader] = useState(false);
  const { sendNotification } = useNotifications();
  const [search, setSearch] = useState("");
  const navigation = useNavigation();
  const [searchData, setSearchData] = useState([]);
  const [searchEmpty, setSearchEmpty] = useState(false);
  const [showCreateLoader, setCreateShowLoader] = useState(false);
  const [userData, setUserData] = useState(null);
  async function getLoginUserData() {
    const data = await getLoginData();

    if (data != null) {
      setUserData(data);
    }
  }
  useEffect(() => {
    getLoginUserData();
    if (showModal) {
      fetchUserSuggestions();
    }
  }, [showModal]);

  const fetchUserSuggestions = async () => {
    setShowLoader(true);
    try {
      const response = await getUsersSuggestion(accessToken);
      setShowLoader(false);

      if (response.statusCode === 200) {
        const suggestions = response.body.results.map((item) => ({
          ...item,
          isSelected: false,
        }));
        setSearchData(suggestions);
      } else {
        toast.error(response.body.error || "Failed to fetch user suggestions");
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };

  const onCloseClick = () => {
    setShowModal(false);
    onClose();
  };

  // Define the debounced function
  const debouncedSearch = useCallback(
    debounce((text) => {
      if (text.length > 0 && userData) {
        const params = {
          query: text,
          currentUsername: userData?.username,
        };

        callSearchAPI({
          bodyParams: params,
          responseSuccess: (response) => {
            if (response) {
              if (Array.isArray(response.results)) {
                if (response.results.length === 0) {
                  setSearchEmpty(true);
                } else {
                  setSearchEmpty(false);
                }
                response.results = response.results.map((item) => {
                  return { ...item, isSelected: false };
                });
                setSearchData(response.results);
              } else {
                setSearchEmpty(true);
              }
            }
          },
        });
      } else {
        setSearchData([]);
      }
    }, 400),
    [userData]
  );

  const onChangeText = (text: String) => {
    setSearch(text.toString());
    debouncedSearch(text);
  };
  const callSendChallengeAPI = async (props) => {
    setCreateShowLoader(true);
    const { bodyParams = {}, responseSuccess } = props;

    try {
      const parsedParams = JSON.parse(bodyParams);
      const { challengeDetails } = parsedParams;
      const { challengerId, eventId, organiserId } = challengeDetails;

      const response = await ChallengeUserNotificationHandler(
        eventId,
        challengerId,
        accessToken
      );
      const statusCode = response.statusCode;

      setCreateShowLoader(false);
      if (statusCode === 200 || statusCode === 201) {
        if (response.statusCode === 200 || response.statusCode === 201) {
          responseSuccess(response.body);
          toast.success("Challenge Successfully sent");

          const { challengerNotificationId, challengerId: responseChallengeId } = response.body;
          console.log("responseChallengeId", responseChallengeId);
          console.log("challengerNotificationId", challengerNotificationId);

          // Track challenge_sent activity
          storeUserActivity(accessToken, eventId, ACTIVITY_TYPES.CHALLENGE_SENT, {
            challengerId: responseChallengeId || challengerId,
          })
            .then((result) => {
              if (result.success) {
                console.log("✅ Challenge sent activity tracked:", result.activityId);
              }
            })
            .catch((err) => console.warn("⚠️ Error tracking challenge sent:", err));

          if (challengerNotificationId) {
            await sendNotification(responseChallengeId, challengerNotificationId);
          } else {
            handleApiError(response.statusCode, "Challenge ID not found");
          }
        } else {
          handleApiError(response.statusCode, response.body?.error || "");
        }
      } else if (statusCode === 500) {
        toast.error(response.body?.error);
        onCloseClick();
        // navigation.dispatch(
        //   StackActions.push(AppScreens.OnGoingEvents, {
        //     eventID: eventId,
        //   })
        // );
      } else {
        handleApiError(statusCode, response.body?.error || "");
      }
    } catch (error) {
      setCreateShowLoader(false);
      toast.error(error.message);
    }
  };
  const callSearchAPI = async ({ bodyParams, responseSuccess }) => {
    setShowLoader(true);
    try {
      const data = await searchUsers(bodyParams);
      setShowLoader(false);

      if (data.statusCode === 200) {
        responseSuccess(data.body);
      } else {
        toast.error(data.body.error || "An error occurred");
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };

  const handlePress = (searchItem, index) => {
    const updatedData = searchData.map((item, i) => ({
      ...item,
      isSelected: i === index, // Only the clicked item is selected
    }));
    setSearchData(updatedData);
  };
  const defaultProfile =
    "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg";

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <LinearGradient
          colors={["#111827", "#000000"]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={styles.mainView}
        >
          <View style={styles.header}>
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_18,
                {
                  fontSize: 24,
                  color: AppColors.white,
                },
              ]}
            >
              Select from friend list
            </Text>
            <TouchableOpacity onPress={onCloseClick} activeOpacity={0.5}>
              <Image
                source={AppImages.icCloseWhite}
                style={{
                  height: 28,
                  width: 28,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
          </View>
          <View style={styles.divider} />

          {/* Search input field */}
          <View
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <View
              style={{
                flexDirection: "row",
                backgroundColor: "#1F2937",
                borderRadius: 8,
                borderWidth: 0.8,
                borderColor: "#374151",
                marginTop: 16,
                marginBottom: 10,
                alignItems: "center",
                width: "95%",
              }}
            >
              <TextInput
                placeholder={"Search candidates here.."}
                multiline={false}
                placeholderTextColor={AppColors.gray_C3C3C3}
                style={[AppFontStyle.REGULAR_ANYBODY_14, styles.textInputStyle]}
                onChangeText={onChangeText}
                keyboardType="default"
                secureTextEntry={false}
                value={search}
              />
              {showLoader ? (
                <ActivityIndicator
                  style={{
                    alignSelf: "center",
                    paddingHorizontal: 10,
                    paddingVertical: 10,
                  }}
                  size="small"
                  color={AppColors.themeColor_0A89AD}
                />
              ) : (
                <Ionicons
                  name="search"
                  size={22}
                  style={{
                    alignSelf: "center",
                    paddingHorizontal: 10,
                  }}
                  color={AppColors.gray_C3C3C3}
                />
              )}
            </View>
          </View>

          <View style={styles.divider} />

          {/* User list */}
          <View style={{ flex: 1, paddingHorizontal: 10 }}>
            <FlatList
              data={searchData}
              style={{
                marginVertical: 10,
                paddingHorizontal: 15,
              }}
              numColumns={deviceSize === DEVICE_SIZES.XS ? 3 : 4}
              keyExtractor={(item) => item.userID.toString()}
              renderItem={({ item, index }) => {
                return (
                  <TouchableOpacity
                    activeOpacity={0.5}
                    style={[
                      styles.itemStyle,
                      {
                        flex: deviceSize === DEVICE_SIZES.XS ? 1 / 3 : 1 / 4,
                        borderColor: item.isSelected
                          ? "#DC2626"
                          : "#1E1E1E",
                        backgroundColor: "transparent",
                      },
                    ]}
                    onPress={() => {
                      handlePress(item, index);
                    }}
                  >
                    {item.isSelected && (
                      <Image
                        source={AppImages.icUserChecked}
                        style={styles.userImageStyle}
                      />
                    )}

                    {/* <View
                      style={{
                        backgroundColor: AppColors.appViolentColor_6D08C3,
                        borderRadius: 50,
                        width: 48,
                        height: 48,
                        justifyContent: "center",
                      }}
                    /> */}
                    <>
                      <View
                        style={{
                          // backgroundColor: AppColors.appViolentColor_6D08C3,
                          borderRadius: 50,
                          width: 48,
                          height: 48,
                          justifyContent: "center",
                        }}
                      >
                        <Avatar
                          src={
                            item.profilePicture
                              ? item.profilePicture
                              : defaultProfile
                          }
                          variant="pastSmallPlayer"
                        />
                      </View>
                      {/* Add ellipsis for long userID */}
                      <Text
                        style={[
                          AppFontStyle.MEDIUM_ANYBODY_12,
                          {
                            color: AppColors.white,
                            textAlign: "center",
                          },
                        ]}
                        numberOfLines={1} // Limit text to one line
                        ellipsizeMode="tail" // Add ellipsis if text is too long
                      >
                        {item.userID}
                      </Text>
                    </>
                  </TouchableOpacity>
                );
              }}
            />
          </View>

          <View style={styles.divider} />

          <View
            style={{
              flexDirection: "row",
              columnGap: 20,
              paddingVertical: 25,
              paddingHorizontal: 10,
            }}
          >
            {/* Back Button */}
            <TouchableOpacity
              style={[
                styles.buttonStyle,
                {
                  backgroundColor: "transparent",
                  borderWidth: 1,
                  borderColor: AppColors.white,
                  flex: 0.6,
                },
              ]}
              activeOpacity={0.5}
              onPress={() => {
                setShowModal(false);
                backTapped();
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_16,
                  styles.buttonTextStyle,
                  {
                    color: AppColors.appViolentColor_6D08C3,
                  },
                ]}
              >
                Back
              </Text>
            </TouchableOpacity>

            {/* Invite to challenge Button */}
            <TouchableOpacity
              style={[styles.buttonStyle, { flex: 1.4 }]}
              activeOpacity={0.5}
              // onPress={() => {
              //   const challengeeID = searchData
              //     .filter((item) => item.isSelected === true)
              //     .map((item) => item.userID);
              //   const challengeDetailsData = {
              //     challengerID: challengeDetail.ChallengerID,
              //     challengeeID: challengeeID,
              //     gameName: challengeDetail.GameName,
              //     type: challengeDetail.Type,
              //     message: challengeDetail.Message,
              //     eventID: challengeDetail.EventID,
              //     organiserID: challengeDetail.OrganiserID,
              //     stakeType: challengeDetail.StakeType,
              //     stakeAmount: challengeDetail.StakeAmount,
              //     timestamp: challengeDetail.DateTime,
              //   };

              //   const param = JSON.stringify({
              //     accessToken: accessToken,
              //     challengeDetails: challengeDetailsData,
              //   });

              //   callSendChallengeAPI({
              //     bodyParams: param,
              //     responseSuccess: (responce) => {
              //       setShowModal(false);
              //       toast.success(responce.message);
              //       successCallback();
              //     },
              //   });
              // }}
              onPress={() => {
                const selectedItem = searchData.find((item) => item.isSelected);
                if (!selectedItem) {
                  toast.error("Please select one opponent");
                  return;
                }
                const challengeDetailsData = {
                  challengerId: selectedItem.userID, // Send a single challengerId
                  type: challengeDetail.Type,
                  eventId: challengeDetail.EventID,
                  organiserId: challengeDetail.OrganiserID,
                };

                const param = JSON.stringify({
                  accessToken: accessToken,
                  challengeDetails: challengeDetailsData,
                });

                callSendChallengeAPI({
                  bodyParams: param,
                  responseSuccess: (response) => {
                    setShowModal(false);
                    toast.success(response.message);
                    successCallback(response);
                  },
                });
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_16,
                  styles.buttonTextStyle,
                  {
                    color: AppColors.white,
                  },
                ]}
              >
                Invite to challenge
              </Text>
            </TouchableOpacity>
          </View>
        </LinearGradient>
        {showCreateLoader && <ShowLoader showIndicater={showCreateLoader} />}
      </View>
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      width: "40%",
      height: "80%",
      paddingHorizontal: 30,
      margin: 30,
      alignSelf: "center",
      borderRadius: 8,
      borderWidth: 1.6,
      borderColor: "rgba(239, 68, 68, 0.50)",
    },
    header: {
      flexDirection: "row",
      justifyContent: "space-between",
      paddingVertical: 25,
      paddingHorizontal: 10,
      alignItems: "center",
    },
    divider: {
      height: 2,
      alignSelf: "center",
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: "100%",
    },
    buttonStyle: {
      flex: 1,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderRadius: 12,
      justifyContent: "center",
      alignItems: "center",
    },
    buttonTextStyle: {
      fontSize: 16,
    },
    footerText: {
      flexDirection: "row",
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      paddingHorizontal: 16,
      paddingVertical: 16,
      borderRadius: 10,
      marginBottom: 20,
      gap: 5,
      alignItems: "center",
    },
    textInputStyle: {
      paddingTop: 16,
      paddingBottom: 16,
      paddingHorizontal: 10,
      color: AppColors.white,
      paddingVertical: 10,
      flex: 1,
      outlineStyle: "none",
    },
    itemStyle: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 12,
      borderWidth: 1,
      padding: 16,
      gap: 16,
      marginHorizontal: 8,
      marginVertical: 8,
    },
    userImageStyle: {
      height: 20,
      width: 20,
      resizeMode: "contain",
      position: "absolute",
      top: 5,
      right: 5,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "50%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 25,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      header: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 25,
        paddingHorizontal: 10,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      buttonStyle: {
        flex: 1,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderRadius: 12,
        justifyContent: "center",
        alignItems: "center",
      },
      buttonTextStyle: {
        fontSize: 14,
      },
      footerText: {
        flexDirection: "row",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 25,
        paddingVertical: 16,
        borderRadius: 10,
        marginBottom: 20,
      },
      textInputStyle: {
        paddingTop: 16,
        paddingBottom: 16,
        paddingHorizontal: 10,
        color: AppColors.white,
        paddingVertical: 10,
        flex: 1,
      },
      itemStyle: {
        flex: 1,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        rowGap: 10,
        borderRadius: 10,
        borderWidth: 1,
        paddingVertical: 16,
        paddingHorizontal: 10,
        marginHorizontal: 10,
        marginVertical: 10,
      },
      userImageStyle: {
        height: 20,
        width: 20,
        resizeMode: "contain",
        position: "absolute",
        top: 5,
        right: 5,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "55%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 16,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      header: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 25,
        paddingHorizontal: 10,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      buttonStyle: {
        flex: 1,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderRadius: 12,
        justifyContent: "center",
        alignItems: "center",
      },
      buttonTextStyle: {
        fontSize: 14,
      },
      footerText: {
        flexDirection: "row",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 25,
        paddingVertical: 16,
        borderRadius: 10,
        marginBottom: 20,
      },
      textInputStyle: {
        paddingTop: 16,
        paddingBottom: 16,
        paddingHorizontal: 10,
        color: AppColors.white,
        paddingVertical: 10,
        flex: 1,
      },
      itemStyle: {
        flex: 1,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        rowGap: 10,
        borderRadius: 10,
        borderWidth: 1,
        paddingVertical: 16,
        paddingHorizontal: 10,
        marginHorizontal: 10,
        marginVertical: 10,
      },
      userImageStyle: {
        height: 20,
        width: 20,
        resizeMode: "contain",
        position: "absolute",
        top: 5,
        right: 5,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "flex-end",
        alignItems: "center",
      },
      mainView: {
        width: "100%",
        height: "85%",
        paddingHorizontal: 16,
        marginHorizontal: 0,
        marginVertical: 0,
        alignSelf: "center",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderWidth: 1,
        borderBottomWidth: 0,
        borderColor: "#DC2626",
        shadowColor: "rgba(232, 232, 232, 0.15)",
        shadowOffset: { width: 0, height: -3 },
        shadowOpacity: 1,
        shadowRadius: 14,
      },
      header: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 15,
        paddingHorizontal: 10,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      buttonStyle: {
        flex: 1,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderRadius: 12,
        justifyContent: "center",
        alignItems: "center",
      },
      buttonTextStyle: {
        fontSize: 14,
      },
      footerText: {
        flexDirection: "row",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 25,
        paddingVertical: 16,
        borderRadius: 10,
        marginBottom: 20,
      },
      textInputStyle: {
        paddingTop: 16,
        paddingBottom: 16,
        paddingHorizontal: 10,
        color: AppColors.white,
        paddingVertical: 10,
        flex: 1,
      },
      itemStyle: {
        flex: 1,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        rowGap: 10,
        borderRadius: 10,
        borderWidth: 1,
        paddingVertical: 16,
        paddingHorizontal: 10,
        marginHorizontal: 10,
        marginVertical: 10,
      },
      userImageStyle: {
        height: 20,
        width: 20,
        resizeMode: "contain",
        position: "absolute",
        top: 5,
        right: 5,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "flex-end",
        alignItems: "center",
      },
      mainView: {
        width: "100%",
        height: "85%",
        paddingHorizontal: 12,
        marginHorizontal: 0,
        marginVertical: 0,
        alignSelf: "center",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderWidth: 1,
        borderBottomWidth: 0,
        borderColor: "#DC2626",
        shadowColor: "rgba(232, 232, 232, 0.15)",
        shadowOffset: { width: 0, height: -3 },
        shadowOpacity: 1,
        shadowRadius: 14,
      },
      header: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 15,
        paddingHorizontal: 10,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      buttonStyle: {
        flex: 1,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderRadius: 12,
        justifyContent: "center",
        alignItems: "center",
      },
      buttonTextStyle: {
        fontSize: 16,
      },
      footerText: {
        flexDirection: "row",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 25,
        paddingVertical: 16,
        borderRadius: 10,
        marginBottom: 20,
      },
      textInputStyle: {
        paddingTop: 16,
        paddingBottom: 16,
        paddingHorizontal: 10,
        paddingVertical: 10,
        color: AppColors.white,
        flex: 1,
      },
      itemStyle: {
        flex: 1,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        rowGap: 10,
        borderRadius: 10,
        borderWidth: 1,
        paddingVertical: 12,
        paddingHorizontal: 10,
        marginHorizontal: 8,
        marginVertical: 8,
      },
      userImageStyle: {
        height: 14,
        width: 14,
        resizeMode: "contain",
        position: "absolute",
        top: 5,
        right: 5,
      },
    },
  }
);
